import { InjectionToken } from '@angular/core';

/** Data passed into a component opened in the slide panel. */
export const SLIDE_PANEL_DATA = new InjectionToken<unknown>('SLIDE_PANEL_DATA');

/** Ref for the slide panel; inject in panel content to call close(). */
export interface SlidePanelRef {
  close(): void;
}

export const SLIDE_PANEL_REF = new InjectionToken<SlidePanelRef>('SLIDE_PANEL_REF');
